import React from 'react';
import MarkdownPage from '../components/MarkdownPage';

const POLICY_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://zwyk0bucket0prod0nuvog6.blob.core.windows.net/zwyk-public-prod/privacy_policy.md'
    : 'https://zwyk0bucket0dev0ygvbi3.blob.core.windows.net/zwyk-public-dev/privacy_policy.md';

const PrivacyPolicy: React.FC = () => (
  <MarkdownPage url={POLICY_URL} loadingText="Ładowanie polityki prywatności…" />
);

export default PrivacyPolicy;
